import React from 'react'
import Document from 'src/modules/Document'

const DocumentPage = () => {
  return <Document />
}
export default DocumentPage
